"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Oct 24 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../../modules/AppModule");

var ApplicationConfigurationConverter_1 = require("./conversions/ApplicationConfigurationConverter");

var ApplicationConfigurationConverterImpl_1 = require("./conversions/ApplicationConfigurationConverterImpl");

var AppRecalcInitiationConverter_1 = require("./conversions/AppRecalcInitiationConverter");

var AppRecalcInitiationConverterImpl_1 = require("./conversions/AppRecalcInitiationConverterImpl");
/**
 * Configures application app module.
 *
 * @author RV
 */


var ApplicationAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ApplicationAppModule, _AppModule_1$AppModul);

  function ApplicationAppModule() {
    var _this;

    _classCallCheck(this, ApplicationAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApplicationAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'applicationAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ApplicationAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ApplicationConfigurationConverter_1.ApplicationConfigurationConverter).to(ApplicationConfigurationConverterImpl_1.ApplicationConfigurationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(AppRecalcInitiationConverter_1.AppRecalcInitiationConverter).to(AppRecalcInitiationConverterImpl_1.AppRecalcInitiationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ApplicationAppModule;
}(AppModule_1.AppModule);

exports.ApplicationAppModule = ApplicationAppModule;